import { Language } from "./user/user-profile/shared/language.enum";

// The transloco lang code for each Language enum value.
const LANGUAGE_CODES: Record<Language, string> = {
    [Language.English]: "en",
    [Language.Dutch]: "nl",
    [Language.Norwegian]: "no",
};

// Every real (non-pseudo) lang code the app can resolve to. Transloco decides whether a string
// passed to setActiveLang/load is a plain lang or a scope path by checking membership in
// setAvailableLangs — so this must be registered there, or "nl"/"no" get misread as an
// (empty) scope name and fail to load.
export const ALL_LANG_CODES: string[] = Object.values(LANGUAGE_CODES);

/** Picks the effective language: the user's own choice, else the tenant default, else English. */
export function resolveEffectiveLanguage(
    userChoice: Language | null,
    tenantDefault: Language | null
): Language {
    return userChoice ?? tenantDefault ?? Language.English;
}

/** Converts a resolved Language into the Transloco lang code passed to setActiveLang. */
export function languageToLangCode(language: Language): string {
    return LANGUAGE_CODES[language] ?? "en";
}
